<template>
  <div style="margin-top:30px; margin-right:15px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <!-- <el-form-item label="卸货时间" prop="time">
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="form.time"
          type="datetime"
          placeholder="选择"
        />
      </el-form-item> -->
      <el-form-item
        label="货物吨位"
        prop="weight"
      >
        <el-input
          v-model="form.weight"
          @input="(value)=>formFormatter.isFloor3(value,oldValue,form,'weight')"
        >
          <template slot="append">
            吨
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="form.coalUnit!=0"
        label="货物数量"
        prop="quantity"
      >
        <el-input
          v-model="form.quantity"
          @input="(value)=>form.coalUnitName=='件'?formFormatter.isInteger(value,oldValue,form,'quantity'):formFormatter.isFloor3(value,oldValue,form,'quantity')"
        >
          <template slot="append">
            {{ form.coalUnitName }}
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        label="卸货单据"
        prop="imgUrl"
      >
        <ImgWatermark :upload-config="{ prefix:'卸货交接单', form: imageFrom}" />
      </el-form-item>
    </el-form>
    <el-dialog
      :visible.sync="showImageFlag"
      :modal="false"
    >
      <img
        width="100%"
        :src="showImageUrl"
        alt
      >
    </el-dialog>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { parseTime,timestampToTime } from '@/utils'
import ImgWatermark from "@/components/ImgWatermark";
import { uploadTicketImage, orderDetailInfoLoadAndUnloadConfirm } from "@/api/transport";
import { maxNumber} from "@/utils/validate4Form.js";
export default {
  components: {
    ImgWatermark,
  },
  data() {
    return {
      pageType: "reunload",
      image: [],
      showImageUrl: "",
      showImageFlag: false,
      preImg: '',
      form: {
        time: "",
        weight: "",
        quantity: "",
        imgUrl: ""
      },
      rules: {
        time: [{ required: true, message: "请选择卸货时间", trigger: "blur" }],
        weight: [
          { required: true, message: "请输入货物吨位", trigger: "blur" },
          { validator:maxNumber, trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: "请输入货物数量", trigger: "blur" },
          { validator:maxNumber, trigger: 'blur' }
        ],
      },
      // 水印
      imgTextUrl:'',
      imgUploadUrl:'',
      file:'',
      renche:'',
      imageFrom: {
        renche:'',
        jiaojie:'',
        imageObj:[],
      },
    };
  },
  created() {
    this.$nextTick(function(){
      this.init()
	    this.conformText()
    })
  },
  methods: {
    init(entity) {
		if(entity){
			this.$set(this.form, "coalUnit", entity.coalUnit);
			this.$set(this.form, "coalUnitName", entity.coalUnitName);
			this.$set(this.form, "code", entity.code);
      this.getDeils(entity.code)
		}
      this.image = [];
      this.imageFrom.renche = ''
      this.imageFrom.jiaojie = ''
      this.$refs.form.resetFields();
    },
    conformText() {
      var canvas = document.createElement("canvas"); //准备空画布
      var ctx = canvas.getContext("2d");
      ctx.font = "14px"; //canvas字体
      ctx.fillText(timestampToTime(), 10, 50);
      var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      gradient.addColorStop("0", "magenta");
      gradient.addColorStop("0.5", "blue");
      gradient.addColorStop("1.0", "red");
      ctx.fillStyle = gradient;
      this.imgTextUrl = canvas.toDataURL("image/png");
    },
    // 获取装货详情
    async getDeils(code){
      const rLoading = this.openLoading();
      let res = await orderDetailInfoLoadAndUnloadConfirm(code)
      let data = res.data
      data.weight = data.unloadWeight
      data.quantity = data.unloadQuantity
      this.form = data
      this.imageFrom.renche = data.ticketImageUrlList[0] || ''
      this.imageFrom.jiaojie = data.ticketImageUrlList[1] || ''
      this.imageFrom.imageObj = data.ticketImageUrlList.splice(2,9) || []
      rLoading.close();
    },
    // 设置货物数量
    setWeight(value,key,name){
      if(name=='件'){
        this.$set(this.form, key, value.replace(/\.[0-9]+/,''))
      }
      else{
        this.$set(this.form, key, value.replace(/([0-9]+\.[0-9]{3})[0-9]*/,'$1'))
      }
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          data.imgUrl = this.imageFrom.renche+',' + this.imageFrom.jiaojie + ',' + this.imageFrom.imageObj.join(',')
          data.time = parseTime(new Date)
          uploadTicketImage(data)
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    },
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
